import o from "./_MapCache.js";
import p from "./_setCacheAdd.js";
import r from "./_setCacheHas.js";
var d = o, c = p, s = r;
function t(e) {
  var a = -1, h = e == null ? 0 : e.length;
  for (this.__data__ = new d(); ++a < h; )
    this.add(e[a]);
}
t.prototype.add = t.prototype.push = c;
t.prototype.has = s;
var n = t;
export {
  n as default
};
//# sourceMappingURL=_SetCache.js.map
